<template>
  <Modal title="请选择投保档次" width="600" v-model="visible" :mask-closable="false" :footer-hide="true" class="my-modal top">
    <div class="table-box">
      <loading :isShow="tableLoading" />
      <Table :columns="columns" :data="gradeList" style="margin-top:20px">
        <template slot-scope="{ row }" slot="name">
          <span class="table-btn" @click="jump(row)">{{row.grade}}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button @click="operateFn(row)" type="primary" v-if="operate=='copyLink'">复制链接</Button>
          <Button @click="jump(row, true)" type="primary" v-if="operate=='copyLink'">在线录单</Button>
          <Poptip
            v-if="operate=='downLoad'"
            trigger="hover"
            content="content"
            :transfer="true"
            @on-popper-show="getQrCode(row)"
            transfer-class-name="channelQrcode"
          >
            <Button type="primary" @click="operateFn(row, index)">下载二维码</Button>
            <template slot="content">
              <div style="width:120px;height:120px" :id="'vueQr'+index">
                <vueQr :text="row.url" :size="120" :margin="0" v-if="row.url" />
              </div>
            </template>
          </Poptip>
        </template>
      </Table>
    </div>
  </Modal>
</template>

<script>
import vueQr from "vue-qr";
export default {
  props: [],
  components: {
    vueQr
  },
  data() {
    return {
      visible: false,
      tableLoading: false,
      operate:"",
      url:"",
      gradeList: [],
      tableItem:{},
      columns: [
        {
          title: "档次",
          slot: "name",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    // 打开弹窗
    open(data,operate) {
      this.tableItem = data;
      this.operate = operate;
      this.visible = true
      this.getGradeList();
    },
    // broker 是否是在线录单 默认客户链接
    async jump(data, broker) {
      this.tableLoading = true;
      let url = await this.getLink(data, broker);
      url = await this.transformLongUrl(url);
      this.tableLoading = false;
      window.open(url);
    },
    async operateFn(data, index){
      if(this.operate == 'copyLink') {
        this.tableLoading = true;
        let url = await this.getLink(data);
        url = await this.transformLongUrl(url);
        this.$units.copyUrl(url)
        this.tableLoading = false;
      } else if(this.operate == 'downLoad') {
        window.setTimeout(()=>{
          const img = document.getElementById('vueQr'+index).querySelector("img").src;
          const a = document.createElement("a");
          const event = new MouseEvent("click");
          a.download = this.tableItem.productName+(data.grade||'');
          a.href = img;
          a.dispatchEvent(event);
        },500)
      }
    },
    async getQrCode(data){
      if(data.url){
        return;
      }
      let url = await this.getLink(data);
      url = await this.transformLongUrl(url);
      this.$set(data,'url',url)
    },
    getLink(data, broker=false){
      return this.$http({
        type: "GET",
        url: "/buz/productBase/startPolicy",
        query: {
          productCode: this.tableItem.productCode,
          userId: this.tableItem.userId,
          grade: data.grade || "",
          type: 2,
          broker: broker,
        },
      }).then((res) => {
        return res.data
      })
    },
    transformLongUrl(url) {
      return this.$http({
        url: "/buz/orderImport/transformLongUrl",
        type: "PUT",
        data: {
          url: url,
        },
      }).then((res) => {
        return res.data;
      });
    },
    getGradeList(){
      this.$http({
        type: "GET",
        url: "/buz/productBase/productGrades",
        query: {
          productCode: this.tableItem.productCode,
          userId: this.tableItem.userId,
        },
      }).then((res) => {
        this.gradeList = res.data;
      });
    }

    
  },
}
</script>

<style lang="scss" scoped>
</style>
